import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

function Multiselect({ edit_data, data, name, isMulti, setIntegrationValue }) {
  const [values, setValues] = useState(edit_data || []);
  const [selectAll, setSelectAll] = useState(false);

  const handleChange = (selectedOptions) => {
    setValues(selectedOptions);
    if (name === 'integration_type') {
      setIntegrationValue(selectedOptions?.value);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setValues([]); // Clear all selections
    } else {
      setValues(data); // Select all options
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    // Initialize state with edit_data if provided
    setValues(edit_data || []);
  }, [edit_data]);

  return (
    <div style={{ position: 'relative' }}>
      {isMulti && (
        <div style={{
          position: "absolute",
          top: "-24px",
          right: "4px",
        }}>
          <label>
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
              style={{ marginRight: '5px' }}
            />
            Select All
          </label>
        </div>
      )
      }
      <Select
        isMulti={isMulti}
        closeMenuOnSelect={!isMulti}
        defaultValue={edit_data}
        value={values}
        onChange={handleChange}
        options={data}
      />
      <input type="hidden" value={JSON.stringify(values)} name={name} />
    </div >
  );
}

export default Multiselect;

Multiselect.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  edit_data: PropTypes.array,
  isMulti: PropTypes.bool,
  setIntegrationValue: PropTypes.func,
};
